/**
 * SchedulePayload created by karora on 29/03/17.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from '../app.component';
import {HeatingEvent} from '../types/heating-event';

class dayEvents {
  day: string;
  events: HeatingEvent[];
}

@Component({
  selector: 'schedule-payload',
  templateUrl: './schedule-payload.component.html',
  styleUrls: ['./schedule-payload.component.css'],
})

export class SchedulePayloadComponent implements OnInit {
  @Input() payload: any;
  DaysOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  processedSchedule: dayEvents[];
  errorMessage: string;

  constructor() { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.processSchedule();
  }

  processSchedule(): void {
    let ps = <dayEvents[]>[];
    let starts: number;
    let startMinute: number;
    let startHour: number;
    for (let event of <HeatingEvent[]>this.payload) {
      if (!event.mow && !event.stop) { continue; }
      if (!event.finish) {
        try {
          if (event.mow) {
            let ends = event.mow.split('-');
            event.start = Number(ends[0]);
            event.finish = Number(ends[1]);
          } else {
            event.finish = Number(event.stop);
          }
          startMinute = event.start % 60;
          starts = (event.start - startMinute) / 60;
          startHour = starts % 24;
          event.dow = (starts - startHour) / 24;
          let day = this.DaysOfWeek[event.dow];

          event.pretty = AppComponent.zpad(startHour, 2);
          event.pretty += ':' + AppComponent.zpad(startMinute, 2);
          event.pretty += '+' + (event.finish - event.start);

//          console.log("Event: " + event.dow + ", " + event.pretty);

          if (ps[day]) {
            ps[day].events.push(event);
          } else {
            ps[day] = <dayEvents>{
              day: this.DaysOfWeek[event.dow],
              events: <HeatingEvent[]>[event],
            };
          }
        } catch (e) {
          console.log('processSchedule: ' + e);
        }
      }
    }
    this.processedSchedule = ps;
  }

  daySchedule(day: string): string {
    let s = '';
    if (!this.processedSchedule[day]) { return s; }
    for (let event of this.processedSchedule[day].events) {
      if (s) {
        s += ', ';
      }
      s += event.pretty;
    }
    return s;
  }
}
